export default "__VITE_ASSET__C2E45yRK__"